import Lottie, { LottieComponentProps } from 'lottie-react';
import animationData from '@shared/animations/congratulations.json';
type CongratsAnimationProps = Omit<LottieComponentProps, 'animationData'> & {
  isFullScreen?: boolean;
};
export const CongratsAnimation = ({
  isFullScreen = false,
  style,
  className,
  ...rest
}: CongratsAnimationProps) => {
  return <Lottie animationData={animationData} className={className} style={isFullScreen ? {
    width: '100vw',
    height: '100vh',
    ...style
  } : style} rendererSettings={{
    preserveAspectRatio: 'xMidYMid slice'
  }} {...rest} data-sentry-element="Lottie" data-sentry-component="CongratsAnimation" data-sentry-source-file="index.tsx" />;
};